import { Box, Badge, styled } from '@mui/material';
import React from 'react';

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-dot': {
		height: 8,
		width: 8,
		'&.online': {
			backgroundColor: theme.palette.success.main
		},
		'&.offline': {
			backgroundColor: theme.palette.secondary.main
		}
	}
}));

const OnlineStatusBadge = ({ online = 'true', children, ...props }) => {
	return (
		<StyledBadge
			{...props}
			overlap="rectangular"
			variant="dot"
			classes={{
				dot: online === 'false' ? 'offline' : 'online'
			}}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right'
			}}
			color="secondary"
		>
			{children && children}
		</StyledBadge>
	);
};

export default OnlineStatusBadge;
